module.exports = {
	"AdUnit": {
		"ad_label": "Annonce"
	},
	"Article": {
		"by": "Af",
		"related_news": "Relaterede nyheder"
	},
	"ArticleShare": {
		"share_article": "Del artiel"
	},
	"PopularVideos": {
		"most_viewed": "Mest læste"
	},
	"AuthorInfo": {
		"show_all": "Vis alt"
	},
	"BlogIndex": {
		"heading1": "Alle",
		"heading2": "blogs",
		"show_more": "Vis flere indlæg fra"
	},
	"CookieNotification": {
		"close": "Luk",
		"description": "Vi anvender egne og tredjeparts cookies til at huske dine indstillinger, til statistik og til at målrette annoncer.",
		"link_text": "Du accepterer cookies ved at klikke videre på siden. Læs mere om brug af cookies og hvordan du sletter dem i vores Privatlivs- og cookiepolitik her."
	},
	"ContentMeta": {
		"all": "Alle",
		"goals": "Mål",
		"game": "Leg",
		"summary": "Sammendrag",
		"highlight": "Highlight",
		"coverage": "Reportage",
		"studio": "Studie",
		"program": "Program",
		"sat-af": "Sat-Af",
		"interview": "Interview",
		"live": "Live",
		"48hclip": " ",
		"vce-clip": " ",
		"discussion": "debat",
		"features": "feature",
		"goal": "mål",
		"match-summary": "kampsammendrag",
		"nostalgia": "nostalgi",
		"top-list": "Top-liste"
	},
	"EmbedPlayer": {
		"not_found": "This clip is no longer available"
	},
	"ExpandableBox": {
		"show_more": "Se mere"
	},
	"FeedContainerBig": {
		"extra": "Extra",
		"top_news": "Seneste nyt",
		"blog": "Blog",
		"podcast": "Podcast"
	},
	"FbCommentBox": {
		"show_comments": "Se kommentarer"
	},
	"FollowFacebook": {
		"heading": "Følg os på Facebook",
		"social_blurb": "Hold dig opdateret"
	},
	"FollowMail": {
		"email_label": "Indsæt din email-adresse",
		"heading": "Tilmeld dig vores nyhedsbrev",
		"see_examples": "Se eksempler",
		"sign_up": "Tilmeld",
		"social_blurb": "Hold dig opdateret",
		"viaplay_option_description": "Seneste nyt om TV, Film og Sport",
		"viaplay_option_title": "Viaplay nyhedsbrev",
		"viasport_option_description": "Sportsnyheder leveret en gang om ugen",
		"viasport_option_title": "TV3 Sport nyhedsbrev"
	},
	"FollowTwitter": {
		"heading": "Følg os på Twitter",
		"social_blurb": "Hold dig opdateret"
	},
	"LeagueIndex": {
		"heading": "Ligaer"
	},
	"LeagueTables": {
		"result": "Resultater",
		"table": "Bord"
	},
	"LiveScoreIndex": {
		"heading": "Livescore"
	},
	"LiveStreamListing": {
		"live": "Live!",
		"today": "I dag",
		"tomorrow": "I morgen"
	},
	"Login": {
		"forgot": "Glemt brugernavn eller password?",
		"heading": "Login",
		"login_button": "Login",
		"login_w_fb": "Login med Facebook login",
		"or": "Eller",
		"password": "Password",
		"username": "Brugernavn",
		"email": "E-mail",
		"coming_soon": "Snart kan du som bruger oprette dit eget personlige område på TV3Sport.dk. Med en brugerprofil, vil du få adgang til en masse eksklusivt sportsindhold, helt gratis! Skriv din e-mail adressse nedenfor, så sørger vi for at holde dig opdateret. ",
		"notify_me": "Send",
		"registration_complete": "E-mail anbefalet!"
	},
	"Mail": {
		"email": "Email"
	},
	"MobileNav": {
		"social_blurb": "Hold dig opdateret"
	},
	"Modal": {
		"close": "Luk"
	},
	"Navbar": {
		"video": "Video",
		"login": "Login",
		"menu": "Menu",
		"popular_teams": "Tophold",
		"popular_leagues": "Topligaer"
	},
	"NoMatch": {
		"heading": "404",
		"body": "Siden, du leder efter, blev desværre ikke fundet!",
		"viasport_startpage": "Klik her for at komme til forsiden"
	},
	"Notifications": {
		"close": "Luk",
		"country_warning": "Vi har registreret at du besøger vores hjemmeside fra et andet land end Danmark. Af ophavsretlige årsager vil nogle videoer ikke være tilgængelige for dig."
	},
	"PageHeading": {
		"news": "Nyheder"
	},
	"PodcastIndex": {
		"heading1": "Alle",
		"heading2": "podcasts",
		"show_more": "Vis alle afsnit af"
	},
	"Poll": {
		"button": "Stem",
		"error": "Din stemme blev ikke gemt."
	},
	"SearchForm": {
		"cancel": "Luk"
	},
	"SearchPage": {
		"results_for": "Søgeresultat efter"
	},
	"Signup": {
		"heading": "Tilmeld",
		"login_button": "Login",
		"or": "Eller",
		"password": "Password",
		"signup_w_fb": "Tilmeld med Facebook",
		"username": "Brugernavn"
	},
	"SocialArea": {
		"email": "Email",
		"social_blurb": "Hold dig opdateret"
	},
	"StoryNav": {
		"next": "Næste artikel"
	},
	"TablesIndex": {
		"heading": "Tabeller"
	},
	"TeamIndex": {
		"heading": "Hold",
		"popular_teams": "Tophold"
	},
	"TotalShares": {
		"total_shares": "Antal delinger"
	},
	"TvGuide": {
		"heading": "TV-guide"
	},
	"TwitterFollowWidget": {
		"follow": "Følg"
	},
	"UnsupportedBrowser": {
		"heading": "Ups, din browser er for gammel og understøttes ikke af tv3sport.dk",
		"body": "Du skal opgradere din browser for at sikre, at alt fungerer som det skal.",
		"meta": "Vi understøtter altid nyeste udgave af disse browsere:",
		"close": "Sulje"
	},
	"UserArea": {
		"login": "Login",
		"signup": "Tilmeld",
		"login_blurb": "Få adgang til premium indhold"
	},
	"ViaplayLiveFeed": {
		"text": "Se sport i verdensklasse - uanset hvor du er. Bestil Viaplay idag.",
		"button": "Prøv det",
		"highlight_streams": "Hovedudsendelser",
		"all_streams": "Alle",
		"link": "http://viaplay.dk/sport",
		"linkText": "Andre udsendelser på viaplay.dk"
	},
	"VideoIndex": {
		"show_clip": "Se klip",
		"show_clips": "Se alle",
		"show_clips_2": "klip",
		"summary": "Alle sammendrag fra",
		"clip": "clip",
		"clips": "clips",
		"heading": "Video",
		"no_events_for_date": "Ingen videoer for denne dato",
		"no_events": "Der er ingen begivenheder",
		"today": "i dag",
		"yesterday": "i går"
	},
	"VideoPlayer": {
		"watch_again": "Afspil videoen igen",
		"related_videos": "Relaterede klip",
		"unsupported_browser": "Hej! Vi ser at du bruger en browser som vi ikke støtter. For at fortsætte med at se anbefaler vi at du",
		"chrome_link_text": "downloader Google Chrome-browseren",
		"video_expired": "Vi beklager, men denne video er tidsbegrænset til 48 timer og er ikke længere tilgængelig"
	},
	"WidgetIndex": {
		"player_info": "Spillerinfo",
		"squad_stats": "Holdinfo"
	},
	"InfiniteScroll": {
		"no_more_articles": "Du har nået enden af flowet."
	},
	"Premium": {
		"heading": "Premium"
	},
	"Thumbnail": {
		"playing": "Nu spiller"
	},
	"Feedback": {
		"widgetTitle": "Del din mening",
		"formTitle": "Din samlede bedømmelse",
		"message": "Hvad kan vi gøre bedre?",
		"name": "Navn",
		"email": "E-mail - (ingen spam)",
		"notify": "Er du interesseret i at modtage information om brugertests fra vores hovedkontor i Stockholm?",
		"close": "Luk",
		"send": "Send"
	}
};


//////////////////
// WEBPACK FOOTER
// ./l10n/da.json
// module id = 692
// module chunks = 6